export default __webpack_public_path__ + "static/media/Chef-1.a5c765fd.jpg";